import classNames from 'classnames';
import { useRouter } from 'next/router';
import React, { FC, useEffect, useState } from 'react';
import HTMLRenderer from 'react-html-renderer';
import VideoPlayer from '../../components/VideoPlayer';
import { useRichImage } from '../../hooks';

import styles from './NewsContent.module.scss';

const ArticleImage = (props: any) => {
  const { src, class: imgClass } = props;
  const url = useRichImage(src, 80);
  return <img alt="img" className={classNames('mt-rich-image', imgClass)} src={url} />;
};

interface Props {
  newsContent: string;
}

const NewsContent: FC<Props> = (props) => {
  const { newsContent } = props;
  const [autoPlay, setAutoPlay] = useState(false);

  const { query, isReady } = useRouter();
  useEffect(() => {
    if (isReady) {
      if (query?.autoPlay) {
        setAutoPlay(true);
      }
    }
  }, [isReady]);

  const firstVideoSrc = newsContent.match(/<video.*?><source.*?src="(.*?)".*?>/i)?.[1];
  let count = 0;

  return (
    <div className={`${styles['newscontent-box']} mt-rich-editor-view`}>
      <HTMLRenderer
        html={newsContent}
        components={{
          video: (propsRender: any) => {
            const { poster = '', width, height, children = {} } = propsRender;
            const videoSrc = children.props.src;
            // 自动播放第一个视频
            let autoplay;
            // 如果获取第一个视频的链接失败，降级为第一个进入该函数的视频
            if (firstVideoSrc) {
              autoplay = autoPlay && firstVideoSrc === videoSrc;
            } else {
              autoplay = autoPlay && count === 0;
              count += 1;
            }
            return videoSrc ? (
              <div className="w-full pt-[10px] lg:pt-[20px] ">
                <VideoPlayer
                  autoplay={autoplay}
                  loop={false}
                  showBigButton
                  poster={poster}
                  source={videoSrc}
                  naturalWidth={width}
                  naturalHeight={height}
                />
              </div>
            ) : null;
          },
          img: ArticleImage,
        }}
      />
      {/* <div dangerouslySetInnerHTML={createNewsHtml()} /> */}
    </div>
  );
};

export default NewsContent;
